'use strict';

/**
 * library
 */

/**
 * module
 */

/**
 * faq
 */
const faq = (() => {
    const $changeFaq = $('.js-change-faq');

    /**
     * init
     */
    const init = () => {
        $changeFaq.each((index, element) => {
            const $this = $(element);

            $this.find('a').on('click', event => {
                event.preventDefault();
                changeFaq(index, $this);
            });
        });
    };

    /**
     * changeFaq
     */
    const changeFaq = (index, $element) => {
        $('.js-change-faq.is-current').removeClass('is-current');
        $element.addClass('is-current');
        $('.js-target-faq.is-current').removeClass('is-current');
        $('.js-target-faq:eq(' + index + ')').addClass('is-current');
    };

    // public
    return {
        init: init
    };
})();

$(() => {
    faq.init();
});
